import { maxWidth, minWidth, width } from "@mui/system";

function createData(
  srNo,
  caseNo,
  customerName,
  caseCreatedBy,
  tiggerScore,
  lob,
  product,
  lossLocation,
  assignedDate,
  tat,
  customerSegment,
  regDate,
  alert,
  code
) {
  return {
    srNo,
    caseNo,
    customerName,
    caseCreatedBy,
    tiggerScore,
    lob,
    product,
    lossLocation,
    assignedDate,
    tat,
    customerSegment,
    regDate,
    alert,
    code,
  };
}

export const rowsData = [
  {
    srNo: 5,
    caseNo: 25,
    customerName: "PARAMESH VERAPPA H C",
    caseCreatedBy: "IM",
    tiggerScore: "HRE",
    lob: "Claim Type 1",
    product: "Motor",
    lossLocation: "Karnataka",
    assignedDate: "02/10/2022",
    tat: 2,
    customerSegment: "Women",
    regDate: "02/10/2022",
    alert: (
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
          fill="#E42125"
        />
        <path
          d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
          fill="#FFFCF2"
        />
        <path
          d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
          fill="#FFFCF2"
        />
      </svg>
    ),
    code: "",
  },
  {
    srNo: 5,
    caseNo: 25,
    customerName: "PARAMESH VERAPPA H C",
    caseCreatedBy: "IM",
    tiggerScore: "HRE",
    lob: "Claim Type 1",
    product: "Motor",
    lossLocation: "Karnataka",
    assignedDate: "02/10/2022",
    tat: 2,
    customerSegment: "Women",
    regDate: "02/10/2022",
    alert: "-",
    code: "",
  },
  {
    srNo: 5,
    caseNo: 25,
    customerName: "PARAMESH VERAPPA H C",
    caseCreatedBy: "IM",
    tiggerScore: "HRE",
    lob: "Claim Type 1",
    product: "Motor",
    lossLocation: "Karnataka",
    assignedDate: "02/10/2022",
    tat: 2,
    customerSegment: "Women",
    regDate: "02/10/2022",
    alert: (
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
          fill="#E42125"
        />
        <path
          d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
          fill="#FFFCF2"
        />
        <path
          d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
          fill="#FFFCF2"
        />
      </svg>
    ),
    code: "",
  },
  {
    srNo: 5,
    caseNo: 25,
    customerName: "PARAMESH VERAPPA H C",
    caseCreatedBy: "IM",
    tiggerScore: "HRE",
    lob: "Claim Type 1",
    product: "Motor",
    lossLocation: "Karnataka",
    assignedDate: "02/10/2022",
    tat: 2,
    customerSegment: "Women",
    regDate: "02/10/2022",
    alert: (
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
          fill="#E42125"
        />
        <path
          d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
          fill="#FFFCF2"
        />
        <path
          d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
          fill="#FFFCF2"
        />
      </svg>
    ),
    code: "",
  },
  {
    srNo: 5,
    caseNo: 25,
    customerName: "PARAMESH VERAPPA H C",
    caseCreatedBy: "IM",
    tiggerScore: "HRE",
    lob: "Claim Type 1",
    product: "Motor",
    lossLocation: "Karnataka",
    assignedDate: "02/10/2022",
    tat: 2,
    customerSegment: "Women",
    regDate: "02/10/2022",
    alert: "-",
    code: "",
  },
];

export const tabsCaseManagement = [
  {
    label: "20 Open",
  },
  {
    label: "20 Allocated",
  },
  {
    label: "20 QC",
  },
  {
    label: "20 Query",
  },
  {
    label: "20 Recommended",
  },
  {
    label: "20 Submitted",
  },
  {
    label: "20 Rejected",
  },
];

export const tabs2CaseManagementVendor = [
  {
    label: "Vendor Details",
  },
  {
    label: "Basic Details",
  },
  {
    label: "Policy Details",
  },
  {
    label: "Proposal Details",
  },

  {
    label: "Claim Details",
    // icon: (
    //   <svg
    //     width="18"
    //     height="16"
    //     viewBox="0 0 18 16"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <path
    //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
    //       fill="#E42125"
    //     />
    //     <path
    //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
    //       fill="#FFFCF2"
    //     />
    //     <path
    //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
    //       fill="#FFFCF2"
    //     />
    //   </svg>
    // ),
  },
  {
    label: "Risk Details",
    // icon: (
    //   <svg
    //     width="18"
    //     height="16"
    //     viewBox="0 0 18 16"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <path
    //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
    //       fill="#E42125"
    //     />
    //     <path
    //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
    //       fill="#FFFCF2"
    //     />
    //     <path
    //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
    //       fill="#FFFCF2"
    //     />
    //   </svg>
    // ),
  },
  {
    label: "Endorsement Details",
  },
  {
    label: "CHASE Smart",
  },
];

export const tabs2CaseManagement = [
  {
    label: "Basic Details",
  },
  // {
  //   label: "Document-Verification Details",
  // },
  {
    label: "Policy Details",
  },
  {
    label: "Proposal Details",
  },
  {
    label: "Claim Details",
    // icon: (
    //   <svg
    //     width="18"
    //     height="16"
    //     viewBox="0 0 18 16"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <path
    //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
    //       fill="#E42125"
    //     />
    //     <path
    //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
    //       fill="#FFFCF2"
    //     />
    //     <path
    //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
    //       fill="#FFFCF2"
    //     />
    //   </svg>
    // ),
  },
  {
    label: "Risk Details",
    // icon: (
    //   <svg
    //     width="18"
    //     height="16"
    //     viewBox="0 0 18 16"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <path
    //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
    //       fill="#E42125"
    //     />
    //     <path
    //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
    //       fill="#FFFCF2"
    //     />
    //     <path
    //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
    //       fill="#FFFCF2"
    //     />
    //   </svg>
    // ),
  },
  {
    label: "Endorsement Details",
  },
  {
    label: "CHASE Smart",
  },
];
export const tabs2CaseManagementSubmitted = [
  {
    label: "FCU Actions",
  },
  {
    label: "Investigation",
    // border: "1px solid #E7373B",
    // bg: "#E8505B",
  },
  {
    label: "Basic Details",
  },
  {
    label: "Policy Details",
  },
  {
    label: "Proposal Details",
  },
  {
    label: "Claim Details",
  },
  {
    label: "Risk Details",
  },
  {
    label: "Endorsement Details",
  },
  {
    label: "CHASE Smart",
  },
  {
    label: "Vendor Payment Details",
  },
];
export const tabs2CaseManagementRecommended = [
  {
    label: "FCU Actions",
  },
  {
    label: "Basic Details",
  },
  {
    label: "Recommendation",
  },
  {
    label: "Policy Details",
  },
  {
    label: "Proposal Details",
  },

  {
    label: "Claim Details",
    // icon: (
    //   <svg
    //     width="18"
    //     height="16"
    //     viewBox="0 0 18 16"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <path
    //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
    //       fill="#E42125"
    //     />
    //     <path
    //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
    //       fill="#FFFCF2"
    //     />
    //     <path
    //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
    //       fill="#FFFCF2"
    //     />
    //   </svg>
    // ),
  },
  {
    label: "Risk Details",
    // icon: (
    //   <svg
    //     width="18"
    //     height="16"
    //     viewBox="0 0 18 16"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <path
    //       d="M7.67065 0.767744L0.205867 13.6962C0.0710267 13.9296 2.49561e-05 14.1945 6.57757e-09 14.4641C-2.49429e-05 14.7337 0.0709278 14.9986 0.205725 15.2321C0.340522 15.4656 0.534413 15.6595 0.767905 15.7943C1.0014 15.9291 1.26626 16 1.53587 16H16.4642C16.7338 16 16.9987 15.9291 17.2322 15.7943C17.4657 15.6595 17.6596 15.4656 17.7944 15.2321C17.9292 14.9986 18.0001 14.7337 18.0001 14.4641C18.0001 14.1945 17.9291 13.9296 17.7942 13.6962L10.3303 0.767744C10.1955 0.534319 10.0016 0.340483 9.76821 0.205716C9.53478 0.0709488 9.26999 0 9.00045 0C8.73091 0 8.46612 0.0709488 8.23269 0.205716C7.99926 0.340483 7.80542 0.534319 7.67065 0.767744Z"
    //       fill="#E42125"
    //     />
    //     <path
    //       d="M9.09792 4.75515H8.9032C8.42379 4.75515 8.03516 5.14378 8.03516 5.62319V9.77227C8.03516 10.2517 8.42379 10.6403 8.9032 10.6403H9.09792C9.57732 10.6403 9.96596 10.2517 9.96596 9.77227V5.62319C9.96596 5.14378 9.57732 4.75515 9.09792 4.75515Z"
    //       fill="#FFFCF2"
    //     />
    //     <path
    //       d="M9.00056 13.931C9.53373 13.931 9.96596 13.4988 9.96596 12.9656C9.96596 12.4324 9.53373 12.0002 9.00056 12.0002C8.46738 12.0002 8.03516 12.4324 8.03516 12.9656C8.03516 13.4988 8.46738 13.931 9.00056 13.931Z"
    //       fill="#FFFCF2"
    //     />
    //   </svg>
    // ),
  },
  {
    label: "Endorsement Details",
  },
  {
    label: "CHASE Smart",
  },
];

export const vendorDetialGrid = {
  label: "Vendor Details",
  tabComponent: [
    {
      label: "Policy Number",
      value: "case/2022-10-13/55113",
    },
    {
      label: "Policy Start Date",
      value: "last week",
    },
    {
      label: "Policy Status",
      value: "Active",
    },
    {
      label: "Claim Number",
      value: "CASE/879/797",
    },
    {
      label: "Policy End Date",
      value: "last week",
    },
    {
      label: "Policy Issue Date",
      value: "last week",
    },
  ],
};

export const CaseManagementMainTableData = [
  // open
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_no",
        label: "Claim No.",
        align: "left",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "im_name",
        label: "Assigned IM",
        align: "left",
        width: "120px",
      },
      {
        id: "assigned_to",
        label: "Assigned To",
        align: "left",
        width: "120px",
      },
      {
        id: "assigned_bs",
        label: "Assigned BS",
        align: "left",
        width: "100px",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "sub_product",
        label: "Sub Product",
        align: "left",
      },
      {
        id: "loss_state",
        label: "Loss State",
        align: "left",
      },
      {
        id: "loss_city",
        label: "Loss City",
        align: "left",
      },
      {
        id: "assigned_date",
        label: "Assigned Date",
        align: "left",
        width: "140px",
      },
      {
        id: "chase_created_date",
        label: "Chase Created Date",
        align: "left",
        width: "140px",
      },
      // {
      //   id: "registration_date",
      //   label: "Reg Date",
      //   align: "left",
      //   width: "110px",
      // },
      {
        id: "severity",
        label: "Severity",
        align: "left",
      },
      {
        id: "claim_value",
        label: "Claim Value.",
        align: "left",
      },
      {
        id: "hospital_name",
        label: "Hospital Name",
        align: "left",
      },
      {
        id: "pin_code",
        label: "Pin Code",
        align: "left",
      },
      {
        id: "diagnosis",
        label: "Diagnosis",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
      {
        id: "tat",
        label: "TAT",
        align: "center",
        minWidth: "70px",
      },
      // {
      //   id: "segmentation",
      //   label: "Customer Segment",
      //   align: "left",
      // },
      // {
      //   id: "claim_intimation_type",
      //   label: "Claim Intimation Type",
      //   align: "center",
      //   minWidth: "130px",
      // },
    ],
  },
  // hold
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Claim No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      // {
      //   id: "claim_no",
      //   label: "Claim No.",
      //   align: "left",
      //   width: "130px",
      //   cursor: "pointer",
      // },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "created_by",
        label: "Case Created By",
        align: "left",
      },
      {
        id: "trigger_source",
        label: "Trigger Source",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
        minWidth: "70px",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "sub_product",
        label: "Sub Product",
        align: "left",
      },
      {
        id: "loss_state",
        label: "Loss State",
        align: "left",
      },
      {
        id: "loss_city",
        label: "Loss City",
        align: "left",
      },

      {
        id: "assigned_date",
        label: "Assigned Date",
        align: "left",
      },
      {
        id: "registration_date",
        label: "Reg Date",
        align: "left",
      },
      {
        id: "severity",
        label: "Severity",
        align: "left",
      },
      {
        id: "tat",
        label: "TAT",
        align: "left",
        minWidth: "70px",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },

      {
        id: "alert",
        label: "Alert",
        align: "center",
      },
    ],
  },
  // Allocated
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_no",
        label: "Claim No.",
        align: "left",
        width: "130px",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
        minWidth: "70px",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "loss_location",
        label: "Loss Location",
        align: "left",
      },
      {
        id: "assigned_date_to_vendor",
        label: "Assigned Date",
        align: "left",
      },
      {
        id: "vendor_case_acceptance_date",
        label: "Accepted Date",
        align: "left",
      },
      {
        id: "ageing",
        label: "Ageing",
        align: "left",
      },
      {
        id: "vendor_name",
        label: "Vendor Name",
        align: "left",
      },
      {
        id: "investigator_name",
        label: "Investigator Name",
        align: "left",
      },
      {
        id: "segmentation",
        label: "Segmentation",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],
  },
  // QC
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_no",
        label: "Claim No.",
        align: "left",
        width: "130px",
      },
      {
        id: "policy_number",
        label: "Policy No.",
        align: "left",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      // {
      //   id: "customer_type",
      //   label: "Customer Type",
      //   align: "left",
      // },
      {
        id: "chase_created_date",
        label: "Chase created date",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
        minWidth: "70px",
      },
      {
        id: "product_category",
        label: "Product Category",
        align: "left",
      },
      // {
      //   id: "trigger_source",
      //   label: "Trigger Source",
      //   align: "center",
      // },
      {
        id: "severity",
        label: "Severity",
        align: "left",
      },
      {
        id: "loss_location",
        label: "Policy Location",
        align: "left",
      },
      {
        id: "zone",
        label: "Zone",
        align: "left",
      },
      // {
      //   id: "policy_location",
      //   label: "Field Investigation Completion Date",
      //   align: "left",
      // },
      {
        id: "tat",
        label: "TAT",
        align: "center",
        minWidth: "70px",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],
  },
  // recommended
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_no",
        label: "Claim No.",
        align: "left",
        width: "130px",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
        minWidth: "70px",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "loss_location",
        label: "Loss Location",
        align: "left",
      },
      {
        id: "recommendation_date",
        label: "Recommendation Date",
        align: "center",
      },
      {
        id: "ageing",
        label: "Ageing",
        align: "left",
      },
      {
        id: "rlm_recommendation",
        label: "RLM Recommendation ",
        align: "center",
      },
      {
        id: "qc_status",
        label: "QC Status",
        align: "center",
      },
      {
        id: "recommendation_status",
        label: "Recommendation Status",
        align: "center",
      },
      {
        id: "recommendation_of",
        label: "Recommendation Of",
        align: "center",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],
  },
  // sumbitted
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_no",
        label: "Claim No.",
        align: "left",
        width: "130px",
      },
      {
        id: "policy_number",
        label: "Policy No",
        align: "left",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Type",
        align: "left",
      },
      {
        id: "chase_created_date",
        label: "chase Created Date",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
        minWidth: "70px",
      },
      {
        id: "trigger_source",
        label: "Trigger Source",
        align: "center",
      },
      {
        id: "severity",
        label: "severity",
        align: "left",
      },
      {
        id: "qc_status_bs_level_1",
        label: "BS",
        align: "left",
        color: "#4DC84D",
        fontWeight: "500",
        minWidth: "100px",
      },
      {
        id: "qc_status_bstl_level_1",
        label: "BSTL",
        align: "left",
        color: "#4DC84D",
        fontWeight: "500",
        minWidth: "100px",
      },
      {
        id: "qc_status_level_1",
        label: "IM",
        align: "left",
        color: "red",
        fontWeight: "500",
        minWidth: "100px",
      },
      {
        id: "qc_status_level_2",
        label: "QC",
        align: "left",
        color: "red",
        fontWeight: "500",
        minWidth: "100px",
      },
      {
        id: "qc_status_level_3",
        label: "RM",
        align: "left",
        color: "red",
        fontWeight: "500",
        minWidth: "100px",
      },
      {
        id: "qc_status_level_4",
        label: "NM",
        align: "left",
        color: "#4DC84D",
        fontWeight: "500",
        minWidth: "100px",
      },
      {
        id: "qc_status_level_5",
        label: "NH",
        align: "left",
        fontWeight: "500",
        color: "#4DC84D",
        minWidth: "100px",
      },
      {
        id: "final_status",
        label: "QC Final Status",
        align: "center",
      },
      {
        id: "sendReminder",
        label: "Send Reminder",
        align: "left",
        fontWeight: "500",
        color: "#1395CC",
      },
      {
        id: "date_of_handover",
        label: "Handover Date",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "submitted_by",
        label: "Submitted By",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "submitted_date",
        label: "Submitted Date",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "closure_category",
        label: "Investigation Type",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],
  },
  // Rejected
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_no",
        label: "Claim No.",
        align: "left",
        width: "130px",
      },
      {
        id: "policy_number",
        label: "Policy No",
        align: "left",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Type",
        align: "left",
      },
      {
        id: "chase_created_date",
        label: "Chase Created Date",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
        minWidth: "70px",
      },
      {
        id: "trigger_source",
        label: "Trigger Source",
        align: "center",
      },
      {
        id: "severity",
        label: "Severity",
        align: "left",
      },
      {
        id: "loss_location",
        label: "Loss Location",
        align: "left",
      },
      {
        id: "rejection_reason",
        label: "Rejection Reason",
        align: "center",
        maxWidth: "150px",
      },
      {
        id: "rejected_at",
        label: "Rejection Date",
        align: "center",
      },
      {
        id: "rejected_by",
        label: "Rejected By",
        align: "center",
      },
      {
        id: "qc_level1",
        label: "IM/QC Review + TAT",
        align: "left",
        fontWeight: "500",
        color: "red",
      },
      {
        id: "qc_level2",
        label: "RM Review + TAT",
        align: "left",
        fontWeight: "500",
        color: "red",
      },
      {
        id: "qc_level3",
        label: "NM Review + TAT",
        align: "left",
        fontWeight: "500",
        color: "red",
      },
      {
        id: "qc_level4",
        label: "NH Review + TAT",
        align: "center",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],
  },
  // Closed
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Claim No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      // {
      //   id: "claim_no",
      //   label: "Claim No.",
      //   align: "left",
      //   width: "130px",
      //   cursor: "pointer",
      // },
      {
        id: "policy_number",
        label: "Policy No",
        align: "left",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Type",
        align: "left",
      },
      {
        id: "chase_created_date",
        label: "Chase created date",
        align: "left",
      },
      {
        id: "lob_name",
        label: "LOB",
        align: "left",
        minWidth: "70px",
      },
      {
        id: "trigger_source",
        label: "Trigger Source",
        align: "center",
      },
      {
        id: "severity",
        label: "Severity",
        align: "left",
      },
      {
        id: "qc_status_level_1",
        label: "QC Status- Level I + TAT",
        align: "left",
        fontWeight: "500",
        color: "red",
      },
      {
        id: "qc_status_level_2",
        label: "QC Status- Level II + TAT",
        align: "left",
        fontWeight: "500",
        color: "red",
      },
      {
        id: "qc_status_level_3",
        label: "QC Status- Level III + TAT",
        align: "left",
        fontWeight: "500",
        color: "green",
      },
      {
        id: "qc_status_level_4",
        label: "QC Status- Level IV + TAT",
        align: "left",
        fontWeight: "500",
        color: "green",
      },
      {
        id: "qc_status_level_5",
        label: "QC Final Status",
        align: "center",
      },
      {
        id: "closure_date",
        label: "Closure Date",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "date_of_handover",
        label: "Handover Date",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "closed_by",
        label: "Closed By",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "closure_category",
        label: "Investigation Type",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "case_initiator",
        label: "Case Initiator",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "case_grade",
        label: "Case Grade",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "closed_by",
        label: "Last Grade Provider",
        align: "left",
        minWidth: "100px",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
    ],
  },
  // Re-Assign
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "case_id",
        label: "Case No.",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "claim_no",
        label: "Claim No.",
        align: "left",
      },
      {
        id: "customer_name",
        label: "Customer Name",
        align: "left",
      },
      {
        id: "im_name",
        label: "Assigned IM",
        align: "left",
        width: "120px",
      },
      {
        id: "assigned_to",
        label: "Assigned To",
        align: "left",
        width: "120px",
      },
      {
        id: "assigned_bs",
        label: "Assigned BS",
        align: "left",
        width: "100px",
      },
      {
        id: "reassigned_by",
        label: "Re-Assigned By",
        align: "left",
        width: "100px",
      },
      {
        id: "product_name",
        label: "Product",
        align: "left",
      },
      {
        id: "sub_product",
        label: "Sub Product",
        align: "left",
      },
      {
        id: "loss_state",
        label: "Loss State",
        align: "left",
      },
      {
        id: "loss_city",
        label: "Loss City",
        align: "left",
      },
      {
        id: "reassigned_date",
        label: "Re-Assigned Date",
        align: "left",
        width: "140px",
      },
      {
        id: "chase_created_date",
        label: "Chase Created Date",
        align: "left",
        width: "140px",
      },
      // {
      //   id: "registration_date",
      //   label: "Reg Date",
      //   align: "left",
      //   width: "110px",
      // },
      {
        id: "severity",
        label: "Severity",
        align: "left",
      },
      {
        id: "claim_value",
        label: "Claim Value.",
        align: "left",
      },
      {
        id: "hospital_name",
        label: "Hospital Name",
        align: "left",
      },
      {
        id: "pin_code",
        label: "Pin Code",
        align: "left",
      },
      {
        id: "diagnosis",
        label: "Diagnosis",
        align: "left",
      },
      {
        id: "customer_segment",
        label: "Customer Segment / Policy flag",
        align: "left",
        maxWidth: "135px",
        width: "135px",
      },
      {
        id: "tat",
        label: "TAT",
        align: "center",
        minWidth: "70px",
      },
      {
        id: "remarks",
        label: "Remarks",
        align: "left",
        minWidth: "150px",
      },

      // {
      //   id: "segmentation",
      //   label: "Customer Segment",
      //   align: "left",
      // },
      // {
      //   id: "claim_intimation_type",
      //   label: "Claim Intimation Type",
      //   align: "center",
      //   minWidth: "130px",
      // },
    ],
  },
];

export const assignBlock = [
  { id: 1, label: "FIR / GD" },
  { id: 3, label: "Treatment Details" },
  { id: 5, label: "Incidence/Accident Details" },
  { id: 6, label: "Charge Sheet Details" },
  { id: 7, label: "Eye Witness" },
  { id: 8, label: "Insured details" },
  { id: 9, label: "Third Party Vehicle Owner" },
  { id: 10, label: "Drivers Licence details" },
  { id: 11, label: "Third Party Drivers Licence details" },
  { id: 12, label: "IV RC details" },
  { id: 13, label: "Third Party RC details" },
  { id: 14, label: "MLC details" },
  { id: 15, label: "IV Driver Details" },
  { id: 16, label: "Third Party Vehicle Driver Details" },
  { id: 17, label: "IV Permit Details" },
  { id: 18, label: "Third Party Permit Details" },
  { id: 19, label: "Profession of the Injured / Deceased Victim" },
  { id: 20, label: "IV Policy details" },
  { id: 21, label: "Third Party Policy details" },
  { id: 22, label: "Insured Verification" },
  { id: 23, label: "Details MVI Reports" },
  { id: 24, label: "Employer Verification & Findings" },
  { id: 25, label: "Hospital Details & Findings" },
  { id: 26, label: "Workshop Verification" },
  { id: 27, label: "Accident Spot Verification" },
  { id: 28, label: "Pharmacy Verification" },
  { id: 29, label: "Spot Panchnamae Details" },
  { id: 30, label: "claimant details" },
  { id: 31, label: "Post Mortem Details" },
  { id: 32, label: "Manage Case Status" },
  { id: 33, label: "Income Details" },
  { id: 34, label: "Diagnostic Center Verification and Finding" },
  { id: 35, label: "Petitioner Block" },
  { id: 36, label: "Treating Doctor Verification/Findings" },
  { id: 37, label: "File Submission History" },
  { id: 38, label: "IV Seizure Memo Details" },
  { id: 39, label: "Third Party Seizure Memo Details" },
  { id: 40, label: "Viscera Report Details" },
  { id: 41, label: "Police Verification" },
  { id: 42, label: "Others" },
  { id: 43, label: "Presence of Loss Location (Insured/Driver)" },
  { id: 44, label: "Additional documents (Uploaded by Investigator)" },
  { id: 45, label: "Associated documents (Uploaded by RLMU)" },
  { id: 46, label: "Case Brief 1" },
  { id: 47, label: "Case Comments" },
  { id: 48, label: "Case Status History" },
  { id: 49, label: "Conclusion" },
  { id: 50, label: "Observation" },
  { id: 4, label: "Post Mort-em Details" },
  {
    id: 2,
    label:
      "Fraud / Suspected Fraud / Loss minimization / No Fraud / Violation of policy terms and conditions",
  },
];

export const dropDownOptions = [
  "Documents awaited",
  "Petition not uploaded",
  "Query raised",
];

// temp const disableSecondTabVal
export const disableSecondTabVal = [
  "Risk Details",
  "Endorsement Details",
  "CHASE Smart",
];

// remove column id for BS and BSTL
export const removeElementForBS = [
  "im_name",
  "qc_name",
  "qc_status",
  "sendReminder",
  "qc_status_level_1",
  "date_of_handover",
  "assigned_bs",
  "bs_name",
  // "assigned_to",
];

// remove column id except IM
export const removeElementExceptIM = ["assigned_bs", "date_of_handover"];

// remove column if for IM
export const removeElementForIM = [
  "assigned_bs",
  "bs_name",
  "bstl_name",
  "qc_status_bs_level_1",
  "qc_status_bstl_level_1",
  "im_name",
  // "assigned_to",
];

// filter Tab value
export const filterTabs = (tabs, removeTab) => {
  return tabs.filter((tab) => !removeTab.includes(tab.label));
};

export const handoverOptions = ["Courier", "Physical Handover"];
export const itemsPerPageBS = 2;

export const allRoles = [
  {
    label: "BS",
  },
  { label: "BSTL" },
  { label: "IM" },
  { label: "QC" },
  { label: "RM" },
  { label: "NM" },
  { label: "NH" },
];
